import { EyeOutlined } from '@ant-design/icons';
import { AppModal } from 'shared/UI/UIKit/Modal';
import { BellScheduleForm } from 'entities/bell-schedule/form';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import type { BellSchedule } from 'services/api';
import { useBellScheduleView } from '../model';
import styles from './styles.module.scss';

interface BellScheduleViewProps {
  bellSchedule: BellSchedule;
}

export const BellScheduleView = ({ bellSchedule }: BellScheduleViewProps) => {
  const {
    state: { modalVisible, form },
    methods: { showModal, hideModal },
  } = useBellScheduleView({ bellSchedule });

  return (
    <>
      <EyeOutlined className={styles.icon} onClick={showModal} />

      <AppModal
        content={<BellScheduleForm form={form} readOnly />}
        title="Просмотр расписания"
        visible={modalVisible}
        onCancel={hideModal}
        destroyOnClose
        footer={
          <AppFlex direction="row">
            <AppButton type="outline" onClick={hideModal}>
              Закрыть
            </AppButton>
          </AppFlex>
        }
      />
    </>
  );
};
